const images = require.context('./' ,false,/^\.\/(?!index).*$/) ;


let logos = {};
images.keys().forEach((key) => { logos[key.replace('./', '').split('.')[0]] = images(key);}) ; 

export function  logocompagnie(compagnie){ 
    if (!compagnie) return '';
   return logos[compagnie?.normalize('NFD').replace(/[\u0300-\u036f\s]+/g, '').toLowerCase()] || logos['noimage']  ; 
}
         